export function TimeKeepingFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/time-keeping-filled.svg'"></ng-include>`
    }
}